import type { EditorPlugin } from './../../ricos-types';

import { unsupportedMark } from './unsupported-mark-extension';
import { unsupportedNode } from './unsupported-node-extension';

// Plugin which helps to handle not-defined nodes/decorations in document
export const unsupportedPlugin: EditorPlugin = {
  type: 'UNSUPPORTED',
  pmMarkConverters: [],
  pmNodeConverters: [],
  shortcuts: [],
  config: {},
  tiptapExtensions: [unsupportedNode, unsupportedMark],
};
